import type { Edge, Face, Vertex } from '@phi/jcore';
import { body_is_for_sketch } from '@frontend/reference_sketches';
import { uil_get_body_of_edge, uil_get_body_of_face, uil_get_body_of_vertex, uil_is_object_visible } from '@frontend/ui_logic';
import { unique } from '@vaaas/fpts/array';

export function invisible_objects() {
    return {
        vertices: invisible_vertices(),
        edges: invisible_edges(),
        faces: invisible_faces(),
    } as const;
}

export const invisible_faces = (): Face[] => unique(uid_faces.keys().filter(is_face_visible));

export const invisible_edges = (): Edge[] => unique(uid_edges.keys().filter(is_edge_visible));

export const invisible_vertices = (): Vertex[] => unique(uid_vertices.keys().filter(is_vertex_visible));

const is_face_visible = (x: Face): boolean =>
    (uid_selected_faces.length > 0 && !uid_selected_faces.hasItem(x))
    || (uil_is_object_visible(x) && body_is_for_sketch(uil_get_body_of_face(x)));

const is_edge_visible = (x: Edge): boolean =>
    (uid_selected_edges.length > 0 && !uid_selected_edges.hasItem(x))
    || (uil_is_object_visible(x) && body_is_for_sketch(uil_get_body_of_edge(x)));

const is_vertex_visible = (x: Vertex): boolean =>
    (uid_selected_vertices.length > 0 && !uid_selected_vertices.hasItem(x))
    || (uil_is_object_visible(x) && body_is_for_sketch(uil_get_body_of_vertex(x)));
